module.exports = __webpack_public_path__ + "f3668ef5f5dbdbe87e649c9a3c0e1f94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/drums-button-pressed-background.png
// module id = 36
// module chunks = 0